const GenRadiosDetailAdapter = resp => {
    let result = [];

    if (!(resp && resp.components && Array.isArray(resp.components.items))) {
        console.log('La api no contiene componentes');
        return result;
    }

    result = resp.components.items.map(radio => {
        let obj = {};
        obj = {
            action: radio.action,
            author: radio.author,
            encoding: radio.encoding,
            entity: radio.entity,
            entity_id: radio.entity_id,
            followers: radio.followers,
            image: radio.img,
            isFollowing: radio.isFollowing,
            name: radio.name,
            url: radio.service_url,
            title: radio.title,
            type: radio.type
        };
        return obj;
    });
    return result;
};

export default GenRadiosDetailAdapter;


// WEBPACK FOOTER //
// ./src/components/GenreRadioList/GenRadiosDetailAdapter.jsx